import {useState} from "react";
import MenuIcon from '@mui/icons-material/Menu';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';

import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

import { useObjectStore } from "../zustand/objects";
import { useAccountStore } from "../zustand/account"; 
import { ActionIcon, Menu } from '@mantine/core';

const MenuButton = ({pageName, iconColour}) => {

 const { saveUserProject, wipeProjectState, unloadObjects } = useObjectStore();
 const { logUserOut, isAuthUser, userStatus} = useAccountStore();

 const [hover, setHover] = useState(false)

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null); 
  };

 
  async function logout() {
    logUserOut() 
  }
 
const handleLogoutClick = () => {
  logout().then(() => window.location.replace('https://mbxr.io/login'))

}

  const handleProjectClick = () => {
    wipeProjectState()
    unloadObjects()
  }

  return (
    <>
      <Menu
        onClose={handleClose}
        style={{ zIndex: 50000 }}
      >
        <Menu.Target>
          <ActionIcon
            onClick={handleClick}
            variant="transparent"
            onPointerOver={() => setHover(true)}
            onPointerLeave={() => setHover(false)}
            bg={'none'}
            size={'sm'}
          >
            <MenuIcon fontSize={'small'} style={{ color: !hover ? iconColour.normal : iconColour.hover}} />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown>

          <Menu.Label>
            Resources
          </Menu.Label>
          {(pageName !== 'projects') && <Menu.Item onClick={handleProjectClick} component="a" href="/projects" leftSection={<ListAltOutlinedIcon fontSize="small" />}>
            Projects
          </Menu.Item>}
          <Menu.Item component="a" target="_blank" href="https://www.matchboxxr.com/how-to" leftSection={<SchoolOutlinedIcon fontSize="small" />}>
              Guides
          </Menu.Item>
          <Menu.Item component="a" target="_blank" href="/templates" leftSection={<StickyNote2OutlinedIcon fontSize="small" />}>
            Template documents
          </Menu.Item>

          <Menu.Label>
            Account
          </Menu.Label>
          <Menu.Item component="a" target="_blank" href="https://forms.gle/J4LkszzrjdimPoQX7" leftSection={<FeedbackOutlinedIcon fontSize="small" />}>
            Give feedback
          </Menu.Item>
          {isAuthUser ? <Menu.Item component="a" href="/account" leftSection={<ManageAccountsOutlinedIcon fontSize="small" />}>
              Account Settings
            </Menu.Item> : <Menu.Item component="a" href="/login" leftSection={<LoginOutlinedIcon fontSize="small" />}>
              Login
            </Menu.Item>}
          {isAuthUser && <Menu.Item onClick={handleLogoutClick} leftSection={<LogoutOutlinedIcon fontSize="small" />}>
            Logout</Menu.Item>}

        </Menu.Dropdown>
      </Menu>

  </>  
  );
};

export default MenuButton;